/**
 * This interface is for the State that is used for keeping track of the logged in agent. This is where we check to
 * see if an agent is logged in and if he is logged in, what his login info and profile data are.
 */
export const initialAuthState = {
    loginInfo: undefined,
    loggedInUser: undefined,
};
